import React from 'react';
import Fields from 'components/Fields';
import { FieldCurrency } from 'components/Base';
import { MetaType } from 'store/modules/Meta/types';
import { CustomerType } from 'store/modules/Customers/types';
import { Field } from 'redux-form';

export const ActionFieldsRenderer = (
  actionType: any,
  transferValue: any,
  policyTypes: MetaType,
  customers: Array<CustomerType>
) => {
  switch (actionType) {
    case 5:
      return (
        <FieldCurrency
          name="retained"
          component={Fields.Text}
          validate={[
            Fields.Validators.isExceedTransferValue(transferValue),
            Fields.Validators.required
          ]}
          label="Amount to transfer"
          shrink
          fullWidth
          placeholder="£0.00"
        />
      );
    case 6:
      return (
        <>
          <Field
            name="owner"
            style={{ margin: '1rem 0' }}
            fullWidth
            validate={Fields.Validators.required}
            options={customers.map((customer: CustomerType) => {
              return {
                name: customer.display_name,
                value: customer.id
              };
            })}
            component={Fields.Select}
            label="Policy owner(s)"
          />
          <Field
            name="type"
            fullWidth
            style={{ margin: '1rem 0' }}
            validate={Fields.Validators.required}
            displayEmpty
            options={policyTypes}
            component={Fields.Select}
            label="Policy type"
          />
        </>
      );
    case 7:
      return (
        <>
          <Field
            name="owner"
            style={{ margin: '1rem 0' }}
            fullWidth
            validate={Fields.Validators.required}
            options={customers.map((customer: CustomerType) => {
              return {
                name: customer.display_name,
                value: customer.id
              };
            })}
            component={Fields.Select}
            label="Policy owner(s)"
          />
          <Field
            name="type"
            fullWidth
            style={{ margin: '1rem 0' }}
            validate={Fields.Validators.required}
            displayEmpty
            options={policyTypes}
            component={Fields.Select}
            label="Policy type"
          />
          <FieldCurrency
            name="retained"
            component={Fields.Text}
            style={{ margin: '1rem 0' }}
            fullWidth
            validate={[
              Fields.Validators.required,
              Fields.Validators.isExceedTransferValue(transferValue)
            ]}
            label="Amount to re-register"
            placeholder="£0.00"
          />
        </>
      );
    default:
      return (
        <FieldCurrency
          name="surrendered"
          component={Fields.Text}
          fullWidth
          validate={[
            Fields.Validators.required,
            Fields.Validators.isExceedTransferValue(transferValue)
          ]}
          label="Amount to surrender"
          shrink
          placeholder="£0.00"
        />
      );
  }
};
